export default __webpack_public_path__ + "static/media/unlike.27ae85dd.png";